(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tk-room"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('toggle', (event) => {
  const pin = event.target;
  if (!pin.classList || !pin.classList.contains('tk-pin') || !pin.open) return;
  document.querySelectorAll('.tk-pin[open]').forEach((other) => { if (other !== pin) other.open = false; });
}, true);
document.addEventListener('click', (event) => {
  if (event.target.closest('.tk-pin')) return;
  document.querySelectorAll('.tk-pin[open]').forEach((pin) => { pin.open = false; });
});

  } catch(e) { console.error(e); }
})();
})();
